// extracted by mini-css-extract-plugin
module.exports = {"root":"LegendControl_root__12W5V","toggle":"LegendControl_toggle__3-c_h","inactive":"LegendControl_inactive__10uaq"};